import { cn } from "@omni/utils/styles";

import { Messages } from "@/components/General/Messages/messages.container";
import { Portal } from "@/components/General/Portal/portal";
import { useWishlistButtonContext } from "@/components/Navigation/Buttons/WishlistButton/context/wishlistButton.context";
import { WISHLIST_MESSAGE_ID } from "@/redux/modules/api/data/wishlist/wishlist.utils";

type Props = {
    className?: string;
};

export const Message = ({ className }: Props) => {
    const { showMessages } = useWishlistButtonContext();

    if (!showMessages) return null;

    return (
        <Portal>
            <Messages
                messageid={WISHLIST_MESSAGE_ID}
                className={cn(
                    "tw:max-w-87.5 tw:fixed tw:mx-4 tw:layer-overlay/[0] tw:left-0 tw:bottom-0",
                    className
                )}
            />
        </Portal>
    );
};
